module.exports = __webpack_public_path__ + "img/contentImg1.3aa1f63a.png";